import { type RefObject, useEffect } from 'react';

import { moveEventHighlight } from '../utils/moveEventHighlight';
import type { CalendarAppointmentEvent } from 'components/mrp/components/Calendar/Calendar.types';
import type { CalendarPosition } from '../CalendarNavigationHandler.types';

type UseTimeStepRoundingParams = {
  position: CalendarPosition | undefined;
  calendarEvents: { [calendarId: string]: CalendarAppointmentEvent[] };
  event: CalendarAppointmentEvent | undefined;
  timeStep: number;
  setEvent: (event?: CalendarAppointmentEvent) => void;
  setPosition: (position?: CalendarPosition) => void;
  pendingRestoreEventId: RefObject<string | number | undefined>;
};

export const useTimeStepRounding = ({
  position,
  calendarEvents,
  event,
  timeStep,
  setEvent,
  setPosition,
  pendingRestoreEventId
}: UseTimeStepRoundingParams) => {
  'use memo';
  useEffect(() => {
    if (!position) return;

    moveEventHighlight({
      pendingRestoreEventId: pendingRestoreEventId.current,
      calendarEvents,
      position,
      timeStep,
      event,
      setEvent
    });

    const totalMinutes = position.date.hour() * 60 + position.date.minute();
    const flooredMinutes = Math.floor(totalMinutes / timeStep) * timeStep;

    if (totalMinutes !== flooredMinutes) {
      setPosition({
        ...position,
        date: position.date.startOf('day').add(flooredMinutes, 'minute')
      });
    }
  }, [
    calendarEvents,
    event,
    pendingRestoreEventId,
    position,
    setEvent,
    setPosition,
    timeStep
  ]);
};
